import { LinkButton } from '@cian/ui-kit';
import * as React from 'react';

import { trackOnlineBookingBookButton } from './tracking';
import { IFavoriteEntity } from '../../types/results';

interface IOnlineBookingBookButton {
  href: string;
  offersQty: number;
  position: number;
  size: 'M' | 'XS';
  entity: Pick<IFavoriteEntity, 'entityId' | 'status' | 'isCianPartner'>;
}

export const OnlineBookingBookButton: React.FC<IOnlineBookingBookButton> = props => {
  const { href, offersQty, entity, position, size } = props;

  const onClick = React.useCallback(() => {
    trackOnlineBookingBookButton(entity, offersQty, position);
  }, [entity, offersQty, position]);

  return (
    <LinkButton href={href} onClick={onClick} fullWidth={true} size={size} target="_blank" rel="noreferrer noopener">
      Проверить даты
    </LinkButton>
  );
};
